export default "__VITE_ASSET__CWHuz__Z__"